

import "./payments";

$(document).ready(function () {

    $('.impact-reports-drop').on('click', function(e) {
        if(!$(this).hasClass('link')) {
            e.preventDefault();
            $('.impact-dropdown-container').toggleClass('show-dropdown');
        }
    });

});